/**
 * Draw order of things that stand on the floor (ADR-0022). Characters and sprite objects share
 * one band between `decor_below` (2) and `decor_above` (1000) and are sorted by the tile row they
 * stand on: lower on screen means in front. On the same row a character is in front of a sprite.
 */
export const FLOOR_DEPTH_BASE = 10;
const ROW_STEP = 1 / 1000; // 256 rows stay far below decor_above
const SPRITE_OFFSET = -ROW_STEP / 10;
const BUBBLE_OFFSET = ROW_STEP / 2;

/** Depth of a character standing on `row`. */
export const characterDepth = (row: number): number => FLOOR_DEPTH_BASE + row * ROW_STEP;

/** Depth of a character on `row` while it shows a speech bubble (above its neighbours). */
export const speakingDepth = (row: number): number => characterDepth(row) + BUBBLE_OFFSET;

/** Depth of a sprite whose bottom row is `sortRow` (see `spriteSortRow`). */
export const spriteDepth = (sortRow: number): number => characterDepth(sortRow) + SPRITE_OFFSET;

/**
 * Depth of a decoration on a piece of furniture whose bottom row is `row` (birthday balloons and
 * cake): in front of that furniture, behind a character on the same row.
 */
export const decorDepth = (row: number): number => characterDepth(row) + SPRITE_OFFSET / 2;
